import { DocumentReducerAction, DocumentReducerState } from './DocumentModel'

const initialState: DocumentReducerState = {
  tree: [],
}

const documentReducer = (state: DocumentReducerState = initialState, action: DocumentReducerAction): DocumentReducerState => {
  switch (action.type) {
    case 'UPDATE_DOCUMENTS':
      if (state.tree !== action.tree) return { tree: action.tree }
      return state
    default:
      return state
  }
}

export default documentReducer
